namespace app.tarefas.minhasTarefas {
    'use strict';

    import IUser = app.autenticacao.IUser;

    declare let angular: ng.IAngularStatic;
    declare let moment: any;

    export class HistoricoTarefasController {
        
        public pagination: IPagination = <IPagination>{
            currentPage: 0,
            pageSize: 20,
            numberOfPages: 1,
            total: 0
        };
        public taskFilters: ITaskFilters = <ITaskFilters> {
            priority: { value: false, active: false },
            assignee: { value: [], active: true  },
            assigneeGroup: { value: [], active: false  },
            completed: { value: true, active: false  },
            cancellation: { value: "!!", active: false  },
            tags: { value: [], active: true  }
        };
        public taskFiltersDefaults: ITaskFilters;
        public taskOrder: string = "startDate";
        public taskOrderDescending: boolean = true;
        public taskViewExpanded: boolean = false;
        
        public msScrollOptions: Object = {
            suppressScrollX: true
        };
    
        public tags: ITaskTag[] = [];
    
        public users: string[] = [];
		
		public usersNames:Map = new Map();
    
        public userLogged: string;
    
        public filteredTasks: ITask[] = [];

        public filteredTasksNoPagination: ITask[] = [];
        
        public exactlySearch = true;
        
        public searchTask: string;
        
        public searchCondition: SearchCondition = SearchCondition.AND;
        
        public isTasksCompletedLoaded: boolean = false;
        
        public isTasksCanceledLoaded: boolean = false;

        public fromDate: Date = moment().subtract(29, "d").startOf("d").toDate();

        public toDate: Date = moment().endOf("d").toDate();

        private static limitTextExtraInfo: number = 470;

        public filterDefault: boolean = true;
    
        private patterns = [{// Processo
            regex: /^([a-zA-Z]+)(\s+)([0-9]{7})$/g,
            replaceFn: (completo: string, sigla: string, espacos: string, numero: string) => {
                return sigla + " " + numero.replace(/^0+/, "");
            }
        }, {// Documento
            regex: /^([0-9]{8})(\-)([0-9]{4})$/g,
            replaceFn: (completo: string, numero: string, traco: string, ano: string) => {
                return numero.replace(/^0+/, "") + traco + ano;
            }
        }, {// Petição
            regex: /^([0-9]{7})([0-9]{4})$/g,
            replaceFn: (completo: string, numero: string, ano: string) => {
                return numero.replace(/^0+/, "") + "/" + ano;
            }
        }];
        
        public tasks: ITask[] = [];

        public openToDate: boolean = false;

        
        /** @ngInject **/       
        constructor(private $filter: ng.IFilterService, 
                    private $scope: ng.IScope,
                    private $window: ng.IWindowService,
                    private $timeout: ng.ITimeoutService,
                    private $state: ng.ui.IStateService,
                    private $mdDialog: ng.material.IDialogService,
                    private minhasTarefasService: MinhasTarefasService,
                    private rotulosService: RotulosService,
                    user: IUser,
                    public userGroups: IGroup[]) {
            
            this.userLogged = user.login;
            this.taskFilters.assignee.value.push(this.userLogged);
            this.taskFiltersDefaults = angular.copy(this.taskFilters);
            
            this.loadSavedSearchData();
            
            this.$scope.$watch(() => this.taskFilters, () => this.watchListener("taskFilters"), true);
            
            this.$scope.$watchCollection(() => this.pagination, () => this.watchListener("pagination"));
            
            angular.forEach(["searchTask", "exactlySearch", "searchCondition",
                             "taskOrder", "taskOrderDescending", "toDate", 
                             "fromDate", "taskViewExpanded"], (prop) => {
                this.$scope.$watch(() => this[prop], () => this.watchListener(prop));
            });
            
            this.loadCompletedTasks(this.fromDate.getTime(), this.toDate.getTime(), this.filterDefault);
            this.loadCanceledTasks(this.fromDate.getTime(), this.toDate.getTime(), this.filterDefault);
        }
        
        private watchListener(property: string): void {
            this.applyTaskFilters();
            this.saveSearchData(property, this[property]);
        }
        
        private saveSearchData(property: string, data: any): void {
            let ls = this.$window.localStorage;
            let stringData = ls.getItem("searchHistoricData");
            let searchData: any;
            
            if (!!stringData) {
                searchData = angular.fromJson(stringData);
            } else {
                searchData = {};
            }
            searchData[property] = data;
            ls.setItem("searchHistoricData", angular.toJson(searchData));
        }
        
        private loadSavedSearchData(): void {
            let ls = this.$window.localStorage;
            let stringData = ls.getItem("searchHistoricData");
            
            if (!!stringData) {
                let searchData = angular.fromJson(stringData);
                
                for (let key in searchData) {
                    if (key === "pagination") {
                        this.pagination.pageSize = searchData.pagination.pageSize;
                        this.pagination.currentPage = searchData.pagination.currentPage;
                    } else if (_.includes(["fromDate", "toDate", "fromDateFilter","toDateFilter"], key)) {
                        this[key] = moment(searchData[key]).toDate();
                    } else {
                        this[key] = searchData[key];
                    }
                }
            }
        }
        
        public clearFilters(): void {
            this.taskFilters = angular.copy(this.taskFiltersDefaults);
            this.applyTaskFilters();
        }        

        public filterByTaskLabels(task: ITask, searchText: string): boolean {                
            if (!searchText || searchText.length < 2) {
                return true;
            }
            if (this.exactlySearch) {
                return this.find(task, searchText);
            } else {
                let filteredText = searchText.split(" ").filter((text) => text !== "");
                let finder = (text: string) => this.find(task, text);
                
                if (this.searchCondition === SearchCondition.AND) {
                    return _.every(filteredText, finder);
                } else {
                    return _.some(filteredText, finder);
                }
            }
        }
        
        public filterByTags(task: ITask, tags: ITaskTag[]): boolean {
            if (tags.length === 0) {
                return true;
            } else {
                let groupTags = _.groupBy(tags, "type");
                
                return _.every(Object.keys(groupTags), (type) => {
                    return _.intersectionBy(task.tags, groupTags[type], "id").length > 0;
                });
            }
        }
        
        public filterByValues(task: ITask, values: any[], filter: string): boolean {
            if (values.length === 0) {
                return true;
            } else {                
                return _.some(values, (v) => {
                    return (v === "!!") ? !!task[filter] : task[filter] === v;
                });
            }
        }      
        
        public applyTaskFilters(): void {
            this.$timeout(() => {
                let tasks = this.tasks
                    .filter((task) => {
                        return _.every(["priority", "completed", "cancellation"], (filter) => {
                            if (this.taskFilters[filter].active) {
                                let value = this.taskFilters[filter].value;
                                if ((filter === "completed" && this.taskFilters.cancellation.active) ||
                                    (filter === "cancellation" && this.taskFilters.completed.active)) {
                                    return true;
                                } else {
                                    return (value === "!!") ? !!task[filter] : task[filter] === value;
                                }
                            } else {
                                return true;
                            }
                        }) && this.filterByValues(task, this.taskFilters["assignee"].value, "assignee")
                           && this.filterByValues(task, this.taskFilters["assigneeGroup"].value, "assigneeGroup")
                           && this.filterByTags(task, this.taskFilters["tags"].value)
                           && this.filterByTaskLabels(task, this.searchTask);
                    });
                tasks = _.orderBy(tasks, this.taskOrder, [this.taskOrderDescending ? "desc" : "asc"]);
                this.filteredTasks = this.paginationFilter(tasks);
                this.filteredTasksNoPagination = tasks;
            }, 500);
        }
        
        public toggleFilter(filter: string, value: string | boolean): void {
            this.taskFilters[filter].active = !this.taskFilters[filter].active;
            
            if (this.taskFilters[filter].active) {
                this.taskFilters[filter].value = value;
            } else {
                this.taskFilters[filter].value = this.taskFiltersDefaults[filter].value;
            }
        }        
        
        public toggleArrayFilter(filter: string, value: any, idSearch?: boolean): void {
            if (!this.isArrayFilterExists(filter, value, idSearch)) {
                this.taskFilters[filter].value.push(value);
            } else if (idSearch) {
                _.remove(this.taskFilters[filter].value, v => v["id"] === value["id"]);
            } else {    
                _.remove(this.taskFilters[filter].value, v => v === value);
            }
        }

        public isArrayFilterExists(filter: string, value: any, idSearch?: boolean): boolean {
            if (idSearch) {
                return this.taskFilters[filter].value.findIndex(o => o.id === value.id) > -1;
            }
            return this.taskFilters[filter].value.indexOf(value) > -1;
        }

        public hasFilteredItems(filter: string, values: [], idSearch?: boolean): boolean {
            for (let item of values) {
                let searchItem = !idSearch && item['id'] ? item['id'] : item;
                let filtered = this.isArrayFilterExists(filter, searchItem, idSearch);
                if (filtered) { return true }
            }
            return false;
        }

        public countTasksWithFilter(filter: any, comparator: boolean): number {
            return this.$filter('filter')(this.tasks, filter, comparator).length;
        }
        
        public taskTrack(task: ITask): string {
            return task.context + "-" + task.id;
        }
        
        public openActiveTasks(): void {
            this.$state.go("app.tarefas.minhas-tarefas");
        }

        public searchHistoricTasks(): void {
            this.tasks = [];

            if (!this.fromDate && !this.toDate) {
                return;
            }
            
            this.fromDate = this.fromDate || moment(this.toDate).subtract(1, 'd').startOf("d").toDate();
            this.toDate = this.toDate || moment().endOf("d").toDate();

            this.tasks = this.tasks.filter(task => !task.completed);
            
            this.loadCanceledTasks(this.fromDate.getTime(), this.toDate.getTime(), this.filterDefault);
            this.loadCompletedTasks(this.fromDate.getTime(), this.toDate.getTime(), this.filterDefault);
        
            this.openToDate = false;
        }
        
        
        public loadCanceledTasks(from: number, to: number, filterByCreateDate: boolean): void {
            this.isTasksCanceledLoaded = false;
            this.minhasTarefasService.listCanceledTasks(from, to, filterByCreateDate)
                .then(canceledTasks => {
                    this.loadHistoricTasks(canceledTasks);
                    this.isTasksCanceledLoaded = true;
                });
        }
        
        public loadCompletedTasks(from: number, to: number, filterByCreateDate: boolean): void {
            this.isTasksCompletedLoaded = false;
            this.minhasTarefasService.listCompletedTasks(from, to, filterByCreateDate)
                .then(completedTasks => {
                    this.loadHistoricTasks(completedTasks);
                    this.isTasksCompletedLoaded = true;
                });
        }

        private loadHistoricTasks(tasks: ITask[]) {
            tasks.forEach((task) => {
                this.loadTags(task);
                this.loadUser(task);
                this.tasks.push(task);
            });
                
            this.sortTags();
            this.applyTaskFilters();
			this.loadUsersNames(tasks);
        }
        
        public isUserGroup(groupId: number) {
            return this.userGroups.some(g => g.id === groupId);
        }
        
        public groupName(groupId: number) {
            let group = this.userGroups.find(g => g.id === groupId);
            return group ? group.nomeArvore : "Não pertencente";
        }
        
        public groupNameParent(group: IGroup) {
            let names = group.nomeArvore.split(" > ");
            names.splice(-1);
            return names.join(" > ");
        }
        
        private paginationFilter(tasks: ITask[]): ITask[] {
            this.validatePageSize();
            this.pagination.total = tasks.length;
            this.pagination.numberOfPages = Math.ceil(tasks.length / this.pagination.pageSize);
            
            if (this.pagination.numberOfPages === 0) {
                this.pagination.numberOfPages = 1;
            } 
            if (this.pagination.currentPage >= this.pagination.numberOfPages) {
                this.pagination.currentPage = this.pagination.numberOfPages - 1;
            }            
            let start = this.pagination.currentPage * this.pagination.pageSize;
            let pageSize = this.pagination.pageSize;
            
            start = +start;
            pageSize = +pageSize;
            
            while (start > tasks.length) {
                start -= pageSize;
            }
            if (start < 0) {
                start = 0;
            }
            return tasks.slice(start, start + this.pagination.pageSize);
        }
        
        private validatePageSize(): void {
            if (!this.pagination.pageSize || this.pagination.pageSize < 1) {
                this.pagination.pageSize = 1;
            } else if (this.pagination.pageSize > 9999) {
                this.pagination.pageSize = 9999;
            }
        }
        
        public paginationPrevious(): void {
            let page = this.pagination.currentPage - 1;
            if (page >= 0) {
                this.pagination.currentPage = page;
            } else {
                this.pagination.currentPage = 0;
            }
        }
        
        public paginationNext(): void {
            let page = this.pagination.currentPage + 1;
            if (page >= this.pagination.numberOfPages) {
                this.pagination.currentPage = this.pagination.numberOfPages - 1;
            } else {
                this.pagination.currentPage = page;
            }
        }
        
        public paginationFirst(): void {
            this.pagination.currentPage = 0;
        }
        
        public paginationLast(): void {
            this.pagination.currentPage = this.pagination.numberOfPages - 1
        }
        
        public formatDate(date: number|string): string {
            return this.$filter("date")(date, "dd/MM/yyyy HH:mm:ss");
        }
        
        private findTask(context: string, id: string): ITask {
            return this.tasks.find((task) => task.id === id && task.context === context);
        }
        
        private loadUser(task: ITask): void {
            if (task.assignee && task.assignee !== this.userLogged) {
                let indexFound = this.users.indexOf(task.assignee);
                
                if (indexFound === -1) {
                    this.users.push(task.assignee);
                    this.users.sort((u1, u2) => this.getUserName(u1).localeCompare(this.getUserName(u2)));
                }
            }
        }
		
		public getUserName(login: string): any {
			if (this.usersNames && login && login != "" && this.usersNames.has(login)) {
				return this.usersNames.get(login);
			}
			return login;
		}
				
		private loadUsersNames(tasks: ITask[]): void {
			let usuarios = new Set();		
			tasks.forEach((task) => {
				if (task.assignee && !this.usersNames.has(task.assignee)) usuarios.add(task.assignee);
				if (task.assignor && !this.usersNames.has(task.assignor)) usuarios.add(task.assignor);
				if (task.cancellation && task.cancellation.canceledBy && !this.usersNames.has(task.cancellation.canceledBy)) usuarios.add(task.cancellation.canceledBy);
				if (task.draft && task.draft.modifiedBy && !this.usersNames.has(task.draft.modifiedBy)) usuarios.add(task.draft.modifiedBy);
								
		    });
			if (usuarios && usuarios.size > 0) {
				this.minhasTarefasService.getNomesUsuarios(Array.from(usuarios)).then(resultado => {
					for (const [key, value] of Object.entries(resultado)) {
						this.usersNames.set(key,value);
						this.users.sort((u1, u2) => this.getUserName(u1).localeCompare(this.getUserName(u2)));
					}
				});
			}
		}
        
        private loadTags(task: ITask): void {
            this.rotulosService.load(task)
                .then(() => {
                    if (task.tags) {
                        task.tags.forEach((tag) => {
                            let indexFound = this.tags.findIndex((t) => t.id === tag.id);
                            
                            if (indexFound === -1) {
                                this.tags.push(tag);
                            }
                        });
                    } else {
                        task.tags = [];
                    }
                });
        }
        
        private sortTags(): void {
            this.tags = _.sortBy(this.tags, ['type', 'name']); 
        }
        
        private find(item: ITask, searchText: string) {
            return this.findBySearchbleId(item,searchText) ||
                this.findByTitle(item,searchText) ||
                this.findByGroupName(item,searchText) ||
                this.findByTagName(item,searchText) ||
                this.findByNotes(item, searchText) ||
                this.findByAssignee(item,searchText) ||
                this.findByStartDate(item,searchText) ||
                this.findByExtraInfo(item, searchText) ||                            
                this.findByModifiedBy(item,searchText) ||                            
                this.findByModifiedDate(item,searchText) ||
                this.findByCanceledBy(item, searchText) ||
                this.findByCanceledDate(item, searchText) ||
                this.findByCanceledReason(item, searchText);
        }

        private findBySearchbleId(item: ITask, text: string): boolean {
            if (!!item.searchableId) {
                for (let pattern of this.patterns) {
                    pattern.regex.lastIndex = 0;
                    if (pattern.regex.test(text)) {
                        pattern.regex.lastIndex = 0;
                        text = text.replace(pattern.regex, pattern.replaceFn);
                        return item.searchableId && item.searchableId.toUpperCase() === text.toUpperCase();
                    }
                }
            }
            return false;
        }

        private findByTitle(item: ITask, text: string): boolean {
            if (!!item.title) {
                return _.deburr(item.title.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
            }
            return false;
        }

        private findByAssignee(item: ITask, text: string): boolean {
            if (!!item.assignee) {
                return item.assignee.toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }
        
        private findByGroupName(item: ITask, text: string): boolean {
            if (!!item.assigneeGroup) {
                return this.groupName(item.assigneeGroup).toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }

        private findByTagName(item: ITask, text: string): boolean {
            if (!!item.tags) {
                return item.tags
                    .filter((tag) => !!tag.name)
                    .some((tag) => _.deburr(tag.name.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1);
            }
            return false;
        }
        
        private findByNotes(item: ITask, text: string): boolean {
            if (!!item.notes) {
                return item.notes.toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }

        private findByStartDate(item: ITask, text: string): boolean {            
            if (!!item.startDate) {
                let data: string = this.formatDate(item.startDate);
                return data.indexOf(text) !== -1;
            }
            return false;
        }

        private findByModifiedDate(item: ITask, text: string): boolean {
            if (!!item.draft && !!item.draft.modifiedDate) {
                let data: string = this.formatDate(item.draft.modifiedDate);
                return data.indexOf(text) !== -1;
            }
            return false;
        }

        private findByModifiedBy(item: ITask, text: string): boolean {
            if (!!item.draft && !!item.draft.modifiedBy) {
                return item.draft.modifiedBy.toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }

        private findByCanceledDate(item: ITask, text: string): boolean {
            if (!! item.cancellation && !!item.cancellation.canceledDate) {
                let data: string = this.formatDate(item.cancellation.canceledDate);
                return data.indexOf(text) !== -1;
            }
            return false;
        }

        private findByCanceledBy(item: ITask, text: string): boolean {
            if (!!item.cancellation && !!item.cancellation.canceledBy) {
                return item.cancellation.canceledBy.toUpperCase().indexOf(text.toUpperCase()) !== -1;
            }
            return false;
        }
        
        private findByCanceledReason(item: ITask, text: string): boolean {
            if (!!item.cancellation && !!item.cancellation.reason) {
                return _.deburr(item.cancellation.reason.toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
            }
            return false;
        }
        
        private findByExtraInfo(item: ITask, text: string): boolean {
            if (!!item.extraInfo) {
                for (let key in item.extraInfo) {
                    if (item.extraInfo[key]) {
                        let encontrou = _.deburr(item.extraInfo[key].toUpperCase()).indexOf(_.deburr(text.toUpperCase())) !== -1;
                        if (encontrou) {
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        private sizeMaxAllowed(valor: string): boolean {
            if(valor.length > HistoricoTarefasController.limitTextExtraInfo) {
                return true;
            }
            return false;
        }

        private sliceTextSize(valor: string): string {
            if(valor.length > HistoricoTarefasController.limitTextExtraInfo) {
              let text = valor.slice(0, HistoricoTarefasController.limitTextExtraInfo);
              let lastSpace = text.lastIndexOf(" ");
              return text.slice(0, lastSpace);
            }
            return valor;
        }

        private openDialogExtraInfo(chave: string, valor: string) {
            let dialog = this.$mdDialog.alert()
                .title(this.convertTextToCapitalize(chave))
                .ok("Fechar")
                .textContent(valor);
            return this.$mdDialog.show(dialog);
        }
        
        private convertTextToCapitalize(text: string): string {
            return text[0].toUpperCase() + text.substr(1);
        } 

        private formatDateDDMMYYYY(date: Date): string {
            return moment(date).format("DD-MM-YYYY");
        } 
        
        public exportarResultado(ev) {
            this.$mdDialog.show({
                controller: "app.tarefas.minhas-tarefas.ExportarTarefasController",
                controllerAs: "vm",
                templateUrl: "app/main/tarefas/minhas-tarefas/dialogs/exportar/exportar-tarefas-dialog.html",
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    tasks: this.filteredTasksNoPagination,
					usersNames: this.usersNames,
                    fromDate: this.formatDateDDMMYYYY(this.fromDate),
                    toDate: this.formatDateDDMMYYYY(this.toDate),
                    fileName: "historico-tarefas"
                }
            });
        }
    
    }

    angular
        .module('app.tarefas.minhas-tarefas')
        .controller('app.tarefas.minhas-tarefas.HistoricoTarefasController', HistoricoTarefasController);
}
